import { MatchMode, MatchType } from "./app.config";

export class LoginModel {
  email_address: string;
  password_hash: string;
  phone: string;
  isHtTandC: boolean;
  userreferCode: string;
}

export class RegisterModel {
  user_name: string;
  email_address: string;
  password_hash: string;
  userreferCode: string;
  token: string;
}

export class SocialModel {
  userreferCode: string;
  email_address: string;
  token: string;
  GmailID: string;
  GmailAccessToken: string;
}

export class ForgetResetModel {
  Mobile_Number: string;
  Token: string;
  OTP: string;
  Password: string;
  CPassword: string;
}

export class UserInfoModel {
  UserId: string;
  ExpireToken: string;
  AuthExpire: string;
}

export class AlmostDoneModel {
  Name: string;
  UserId: string;
  ExpireToken: string;
  AuthExpire: string;
  Team_Name: string;
  State_Name: string;
  AvtaarID: string;
}

export class VerifySendOtpModel {
  Mobile_Number: string;
  UserId: string;
  ExpireToken: string;
  AuthExpire: string;
  Otp: string;
}

export class PlayerListModel {
  response: any;
  condition: ConditionModel;
  players: any;
  team1Id: string;
  team12d: string;
  team13d: string;
}

export class PanVerifyModel {
  panNumber: string;
  name: string;
  dob: string;
  stateName: string;
  photo: any;
}

export class PreveiwModel {
  IsSelected: boolean;
  PlayerName: string;
  PlayerPoint: string;
  role: string;
  Name: string;
  Image: string;
  Credits: string;
  PlayerRole: string;
  sortKey: number;
  category: string;
}

export class ConditionModel {
  categories: any;
  maxPlayer: number;
  minTeamPlayer: number;
  selectePlayerLength: number;
  totalPlayerLength: number;
  team1length: number;
  team2length: number;
  team3length: number;
  SportsID: number;
  credits: number;
  seletedPlayerTypePostion: number;
  maxPlayerError: string;
  MaxPlayerOneTeamError: string;
  MinPlayerError: string;
}

export class PrivateLeagueModel {
  contestName: string;
  fee: number;
  amount: number;
  size: number;
  allow: boolean;
  Fee: number;
}

export class UserInfoProfileModel {
  gender: string;
  name: string;
  UserId: number;
  dob: any;
  state: string;
  address: string;
  pinCode: number;
  teamName: string;
  email: string;
  mobile: string;
}

export class AvtaarModel {
  avtaarId: number;
}

export class InviteCodeModel {
  leaugeCode: number;
}

export class FeedbackModel {
  name_f: string;
  email_f: string;
  title_f: string;
  category_f: string;
  description_f: string;
}

export class StoredDataModel {
  public getUserInfo: any;
  public seriesRank: any;
  public walletInfo: any;
  public levels: any;
  public getAmount: any;
  public sportType = [];
}
